import { urls } from "../../../urls";

const prefixOf = (template: string) => template.split("/:")[0];

const PREFIX_PAIRS: ReadonlyArray<readonly [portal: string, shell: string]> = [
  [urls.portal.list, urls.v2.supplier.procurements],
  [urls.portal.contributions, urls.v2.supplier.contributions],
  [prefixOf(urls.portal.contribution.pathname), prefixOf(urls.v2.supplier.contribution.pathname)],
  [prefixOf(urls.portal.contributionReview.pathname), prefixOf(urls.v2.supplier.contributionReview.pathname)],
];

export const portalPathToShell = (pathname: string): string => {
  for (const [portal, shell] of PREFIX_PAIRS) {
    if (pathname === portal || pathname.startsWith(`${portal}/`)) return shell + pathname.slice(portal.length);
  }
  return urls.v2.supplier.procurements;
};
